import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import * as t from "io-ts";
import { singularityStore } from "@/store/store";

const HeaderAndFooterBlocksResponseV = t.type({
  data: t.type({
    header: t.union([t.number, t.null]),
    footer: t.union([t.number, t.null])
  })
});

type HeaderAndFooterBlocksResponse = t.TypeOf<typeof HeaderAndFooterBlocksResponseV>;

export async function fetchHeaderAndFooterBlockIdsAndSyncToStore(): Promise<{ header: number | null; footer: number | null }> {
  const response = await makeWordPressAjaxRequest({
    action: "breakdance_futurelayer_get_header_and_footer_blocks",
    decoder: HeaderAndFooterBlocksResponseV,
    friendlyName: "Get header and footer blocks",
  });

  const blockIds = pipe(
    response,
    fold(
      () => ({ header: null, footer: null }),
      (result: HeaderAndFooterBlocksResponse) => result.data
    )
  );

  singularityStore.setHeaderAndFooterBlockIdsInWP({
    headerId: blockIds.header || undefined,
    footerId: blockIds.footer || undefined
  });

  return blockIds;
}